import { all, call, put, takeEvery } from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import { getAllLedgerEntrys, getAllPaymentReceiptsResponse, getPaymentReceiptByIdResponse } from "../actions";
import { axiosPost } from "../../utils/common/axios";
import { createEntitySagas, extractPayloadAndCallback, runOptimisticAction, toQuery } from "./sagaHelpers";

export const paymentReceiptEntity = createEntitySagas({
  entity: "paymentreceipt",
  endpoint: "payment-receipts",
  label: "Payment receipt",
  scope: "company",
  computedFields: ["linkedLedgerEntryId"],
  selectSlice: (state) => state.paymentreceipt,
  listKey: "receipts",
  types: {
    getAll: types.GET_ALL_PAYMENT_RECEIPTS,
    getById: types.GET_PAYMENT_RECEIPT_BY_ID,
    create: types.CREATE_PAYMENT_RECEIPT,
    update: types.UPDATE_PAYMENT_RECEIPT,
    remove: types.DELETE_PAYMENT_RECEIPT,
  },
  actions: { getAllResponse: getAllPaymentReceiptsResponse, getByIdResponse: getPaymentReceiptByIdResponse },
});

// payload: { id, engagementId, status, ledgerType, ledgerCategory }
function* approveSaga(action) {
  const { payload, callback } = extractPayloadAndCallback(action);
  const { id, engagementId, status, ledgerType, ledgerCategory } = payload;
  const data = yield* runOptimisticAction({
    entity: "paymentreceipt",
    selectList: paymentReceiptEntity.selectList,
    id,
    changes: { status },
    request: () => axiosPost(`payment-receipts/${id}/approve${toQuery({ status, ledgerType, ledgerCategory })}`),
    successMessage: "Receipt approved and posted to wallet",
    errorFallback: "Could not approve receipt",
    callback,
  });
  if (data && engagementId) yield put(getAllLedgerEntrys({ engagementId, silent: true }));
}

// payload: { id, status, rejectionReason }
function* rejectSaga(action) {
  const { payload, callback } = extractPayloadAndCallback(action);
  const { id, status, rejectionReason } = payload;
  yield* runOptimisticAction({
    entity: "paymentreceipt",
    selectList: paymentReceiptEntity.selectList,
    id,
    changes: { status, rejectionReason },
    request: () => axiosPost(`payment-receipts/${id}/reject${toQuery({ status, rejectionReason })}`),
    successMessage: "Receipt rejected",
    errorFallback: "Could not reject receipt",
    callback,
  });
}

export function* paymentreceiptSaga() {
  yield all([
    call(paymentReceiptEntity.watcher),
    takeEvery(types.APPROVE_PAYMENT_RECEIPT, approveSaga),
    takeEvery(types.REJECT_PAYMENT_RECEIPT, rejectSaga),
  ]);
}
